export const SELF_ADS_COLORS = {
  shellBg: "blackAlpha.500",
  cardBg: "blackAlpha.800",
  cardBorder: "whiteAlpha.100",
  accent: "primary.500",
  accentMuted: "rgba(99, 102, 241, 0.15)",
  accentShadow: "shadow-primary-xl",
  accentBg: "primary.400/10",
  title: "primary.50",
  body: "neutral.300",
  label: "primary.400",
} as const;
